import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'callFunction',
    standalone: false,
})
export class CallFunctionPipe implements PipeTransform {
    public transform<T>(
        _function: (...args: unknown[]) => T,
        ...args: unknown[]
    ): T {
        return _function(...args);
    }
}
